<style lang="less" scoped>
  .dot-wrap{
    position: relative;
  }
  .active-dot{
    animation: active-dot 2s infinite;
  }
  .comment-content{
    font-style: italic;
  }
  .link-user-container {
    margin-left: 23px;
    margin-bottom: 15px;
    .link-title {
      margin-left: 5px;
      cursor: pointer;
    }
    .link-user-add-btn {
      cursor: pointer;
      border: 1px solid #999;
      border-radius: 2px;
      transition: .3s;
      &:hover {
        color: #2b62e4;
        transform: scale3d(1.2, 1.2, 1);
        box-shadow: 0 1px 3px rgba(100,100,100,.3);
      }
    }
  }
</style>
<template>
  <div>
    <div
      class="link-user-container"
    >
      <Icon
        class="link-user-add-btn"
        size="14"
        type="md-add"
        @click="addLinkUser"
      />
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <span
            class="link-title"
            v-bind="attrs"
            v-on="on"
          >
            抄送
          </span>
        </template>
        <span>抄送人员可以在【与我相关】中查看该流程</span>
      </v-tooltip>
      <div
        style="padding: 0 25px"
      >
        <CustomerName
          v-for="(user, index) in user_flow.link_users"
          :id="user.id"
          :key="user.id"
        >
          <template v-slot="{item}">
            <span class="link-grey text-bold new-element-effect">{{ item.account }}</span>
            <span v-if="index < user_flow.link_users.length - 1">, </span>
          </template>
        </CustomerName>
        <span
          v-if="!user_flow.link_users || !user_flow.link_users.length"
          class="color-grey"
        >
          无抄送人员
        </span>
      </div>
    </div>
    <Timeline>
      <TimelineItem
        v-for="flow_node in user_flow.unfinished_flow_nodes"
        :key="`u${flow_node.id}`"
        :color="getNodeColor(-1)"
      >
        <span
          slot="dot"
          class="dot-wrap"
        >
          <Icon
            type="md-radio-button-off"
            size="16"
          />
        </span>
        <div>
          <span class="color-grey">{{ flow_node.name }}</span>
          <span
            v-if="flow_node.desc"
            class="color-warning"
          >{{ flow_node.desc }}</span>
        </div>
        <div
          v-if="isShowFlowNodeEstimatedTime(flow_node)"
          class="color-info"
        >
          预计完成日期: {{ estimatedTime(flow_node) }}
        </div>
      </TimelineItem>
      <TimelineItem
        v-if="user_flow.del_user_id > 0"
        color="red"
      >
        <span
          slot="dot"
          class="dot-wrap"
        >
          <Icon
            type="md-radio-button-off"
            size="16"
          />
        </span>
        <div class="color-error">
          流程已废弃
        </div>
        <div>
          <CustomerName :id="user_flow.del_user_id">
            <template v-slot="{ item }">
              <span class="text-bold link-grey">{{ item.account }}</span>
            </template>
          </CustomerName>
          <span class="color-error">[已废弃]</span>
          <span>[{{ $util.formatTime(user_flow.del_at) }}]</span>
        </div>
        <div class="">
          废弃原因: {{ user_flow.del_reason || '未填写' }}
        </div>
      </TimelineItem>
      <TimelineItem
        v-for="user_node in user_flow.user_flow_nodes"
        :key="user_node.id"
        :color="getNodeColor(user_node.status)"
      >
        <span
          slot="dot"
          class="dot-wrap"
        >
          <Icon
            v-if="isCurNode(user_node)"
            type="md-radio-button-on"
            class="active-dot"
            size="18"
          />
          <Icon
            v-else
            type="md-radio-button-off"
            size="16"
          />
        </span>
        <div>
          <span>{{ user_node.flow_node_name }}</span>
          <span
            v-if="user_node.flow_node.desc"
            class="color-warning"
          >{{ user_node.flow_node.desc }}</span>
        </div>
        <div
          v-if="isShowUserNodeEstimatedTime(user_node)"
          class="color-info"
        >
          预计完成日期: {{ estimatedTime(user_node.flow_node) }}
        </div>
        <div>
          <div
            v-for="node_user in user_node.user_flow_node_users"
            :key="node_user.id"
          >
            <CustomerName :id="node_user.customer_id">
              <template v-slot="{ item }">
                <span class="link-grey text-bold">{{ item.account }}</span>
              </template>
            </CustomerName>
            <span v-html="getNodeUserStatus(node_user, user_node)" />
            <span>[{{ updateTime(node_user) }}]</span>
            <div v-if="node_user.comment">
              <span>备注:</span>
              <span
                style="white-space: pre"
                class="comment-content"
              >
                {{ node_user.comment }}
              </span>
            </div>
            <div v-if="node_user.transferers">
              <div class="">
                节点转移历史:
              </div>
              <div v-html="genTransferHtml(node_user)" />
            </div>
            <div
              v-if="node_user.is_invite"
              class=""
            >
              <CustomerName :id="node_user.inviter.id">
                <template v-slot="{ item }">
                  <span class="link-grey text-bold">{{ item.account }}</span>
                </template>
              </CustomerName>
              邀请<span> {{ getInvitee(node_user) }} </span>加入审核
            </div>
            <div v-if="node_user.invite_reason">
              <span>邀请原因:</span>
              <span
                class="comment-content"
                v-html="node_user.invite_reason"
              />
            </div>
          </div>
        </div>
      </TimelineItem>
    </Timeline>
  </div>
</template>
<script>
  import Util from '../../../libs/util';
  import FlowUtil from '../../../libs/flow_util';
  export default {
    props: {
      user_flow: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        //
      }
    },
    computed: {
      //
    },
    watch: {
      user_flow(new_user_flow, old_user_flow) {
        this.removeEventListener(old_user_flow);
        this.addEventListener(new_user_flow);
      }
    },
    created() {
      //
    },
    mounted() {
      this.addEventListener(this.user_flow);
    },
    beforeDestroy() {
      this.removeEventListener(this.user_flow);
    },
    methods: {
      addEventListener(user_flow) {
        if (user_flow && user_flow.id) {
          window.eventHub.$on(`update-user-flow-${user_flow.id}`, this.updateUserFlow);
        }
      },
      removeEventListener(user_flow) {
        if (user_flow && user_flow.id) {
          window.eventHub.$off(`update-user-flow-${user_flow.id}`, this.updateUserFlow);
        }
      },
      getNodeColor(status) {
        let color = '';
        switch (status) {
        case 0:
          color = 'blue';
          break
        case 1:
          color = 'green';
          break;
        case 2:
          color = 'red';
          break;
        case 3:
          color = '#f90';
          break;
        default:
          color = '#aaa';
          break;
        }
        return color;
      },
      getNodeUserColor(status) {
        let color = '';
        switch (status) {
        case 0:
          color = '#2D8CF6';
          break;
        case 1:
          color = '#19be6b';
          break;
        case 2:
          color = '#ed3f14';
          break;
        default:
          color = '#aaa';
          break;
        }
        return color;
      },
      getNodeUserStatus(user_flow_node_user, user_flow_node) {
        return `[${FlowUtil.userFlowNodeUserStatusHtml(user_flow_node_user, user_flow_node)}]`;
      },
      getInvitee(node_user) {
        if (node_user.transferers) {
          return node_user.transferers.split('@@')[0];
        } else {
          return node_user.customer_account;
        }
      },
      updateTime(node_user) {
        return Util.formatTime(node_user.handled_at || node_user.updated_at);
      },
      isCurNode(user_node) {
        const is_cur = this.user_flow.cur_node_id === user_node.id;
        return is_cur && !this.user_flow.is_finish && this.user_flow.del_user_id === 0;
      },
      genTransferHtml(node_user) {
        const names = node_user.transferers.split('@@');
        const reasons = node_user.transfer_reason.split('@@');
        let text = '';
        names.forEach((name, index) => {
          text += `${name}(${reasons[index]}) → `
        });
        text += node_user.customer_account;
        return text;
      },
      isShowFlowNodeEstimatedTime(flow_node) {
        return flow_node.duration && this.user_flow.user_flow_nodes.length > 1;
      },
      isShowUserNodeEstimatedTime(user_node) {
        return user_node.status === 0 && user_node.flow_node.duration && this.user_flow.user_flow_nodes.length > 1;
      },
      estimatedTime(flow_node) {
        const first_node = this.user_flow.user_flow_nodes[0];
        const start_time = new Date(first_node.handled_at || first_node.updated_at).getTime();
        const duration = flow_node.duration;
        const end_time = start_time + duration * 24 * 3600 * 1000;
        return Util.formatDate(end_time);
      },
      updateUserFlow(user_flow) {
        Object.keys(this.user_flow).forEach((key) => {
          this.user_flow[key] = user_flow[key];
        });
      },
      addLinkUser() {
        window.eventHub.$emit('show-add-link-user', this.user_flow.id)
      }
    }
  }
</script>
